import type React from 'react';

import classNames from 'classnames';

export interface PageHeaderProps {
  children: React.ReactNode;
  withPadding?: boolean;
  className?: string;
}
const PageHeader = ({ children, className, withPadding }: PageHeaderProps) => {
  return (
    <div
      className={classNames(
        'Mfw-Page-header',
        {
          'px-2': withPadding,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default PageHeader;
